import { useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router';
import useEkko from 'src/Common/Providers/EkkoProvider';
import { PageAccessMap } from 'src/Menus';

export const NoPermissionsContent = (): React.JSX.Element => {
  const { logOut, hasPermission, isAuthenticated } = useEkko();
  const navigate = useNavigate();

  const fallbackRoute = useMemo(() => {
    for (const a of Object.values(PageAccessMap)) {
      if (a.disabled !== true && hasPermission(a.permission)) {
        return a.route.path;
      }
    }

    return undefined;
  }, [hasPermission]);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate('/login');
      return;
    }

    if (fallbackRoute !== undefined) {
      console.log('[UI] redirect to:', fallbackRoute);
      navigate(fallbackRoute);
    } else {
      logOut();
      navigate('/login');
    }
  }, [fallbackRoute, logOut, navigate, isAuthenticated]);

  return <></>;
};
